import React, { useState } from "react";
import Checkbox from "../ui/checkbox/checkbox";

interface AgeVerificationModalProps {
  onYes: () => void;
  onNo: () => void;
}

const AgeVerificationModal: React.FC<AgeVerificationModalProps> = ({ onYes, onNo }) => {
  const [checked, setChecked] = useState(false);

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(28, 15, 44, 0.9)",
          zIndex: 9998,
        }}
      />
      <div
        className="position-fixed rounded-15 p-4"
        style={{
          background: "linear-gradient(135deg, #1a0f33 0%, #2d1a5c 100%)",
          border: "1px solid #8c2fb8",
          zIndex: 9999,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minWidth: "320px",
          maxWidth: "90%",
          boxShadow: "0 0 20px rgba(140, 47, 184, 0.5)",
        }}
      >
        <p className="fs-20 fw-700 text-white text-center mb-3">Are you 18+ ?</p>
        <p className="fs-14 fw-600 text-white-50 text-center mb-3">
          By continuing you agree that you are 18 years old or older.
        </p>
        <div className="mb-3 d-flex justify-content-center">
          <Checkbox
            checked={checked}
            onChange={e => setChecked(e.target.checked)}
            label={<span className="text-white">I confirm I am 18+ </span>}
          />
        </div>
        <div className="d-flex justify-content-center">
          <button
            className="white-flat-btn fw-bold py-1 px-4 m-auto mb-2 me-2"
            disabled={!checked}
            onClick={onYes}
          >
            Yes
          </button>
          <button className="white-flat-btn fw-bold py-1 px-4 m-auto mb-2 ms-2" onClick={onNo}>
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default AgeVerificationModal;
